<div class="flex space-x-3.5 w-1/2 h-full">
  <div class="container-background rounded-lg grow item w-full h-full overflow-y-auto relative">
    <!-- Metadata custom client Allianz -->
    <div class="header rounded-lg flex sticky top-0 asset-details p-4 z-50">
      <div class="title w-3/5 font-bold text-xl">Metadata</div>
      <div class="actions w-2/5 text-right">
        <button class="save-button pl-4 cursor-pointer" role="button" *ngIf="editFlag" (click)="saveCollectionInfo()">
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
        <button class="pl-4 cursor-pointer" role="button" *ngIf="editFlag" (click)="editInformation()">
          <mat-icon class="material-icons-outlined">close</mat-icon>
        </button>
        <button class="cursor-pointer" role="button" *ngIf="!editFlag" (click)="editInformation()">
          <mat-icon class="material-icons-outlined">edit</mat-icon>
        </button>
      </div>
    </div>
    <div class="details pt-1 px-4 -mt-2">
      <div class="detail-header">
        <div class="pb-1" *ngIf="!editFlag">
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Team</span>
            <div class="inline-block w-4/5 break-words">
              <span>{{ collectionCustomFields?.team?.name }}</span>
            </div>
          </div>
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Target group</span>
            <div class="inline-block w-4/5 break-words">
              <span>{{ collectionCustomFields?.targetGroup?.name }}</span>
            </div>
          </div>
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Agency</span>
            <div class="inline-block w-4/5 break-words">
              <span>{{ collectionCustomFields?.agency }}</span>
            </div>
          </div>
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Campaign year</span>
            <div class="inline-block w-4/5 break-words">
              <span>{{ collectionCustomFields?.campaignYear.name }}</span>
            </div>
          </div>
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Contact person</span>
            <div class="inline-block w-4/5 break-words">
              <span>{{ collectionCustomFields?.contactPerson }}</span>
            </div>
          </div>
          <div class="py-1 flex items-start">
            <span class="w-2/5 inline-block">Internal comment</span>
            <div class="inline-block w-4/5 break-words">
              <div class="ql-container ql-snow !bg-inherit !border-0">
                <div class="ql-editor !p-0 !overflow-y-hidden" [innerHTML]="collectionCustomFields?.internalComments"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-1" *ngIf="editFlag">
          <form class="asset-info-form" [formGroup]="collectionMetadataForm">
            <div>
              <span class="w-2/5 field-label">Team</span>
              <sp-mat-select-search
                class="w-3/5 inline-block"
                formControlName="team"
                [dataSource]="teamTypes"
                [placeholder]="'Select team'"
                [config]="{ search: true, required: true, requiredText: 'Team is required' }"
                [attrDataTestId]="'custom-client-metadata_team'"
              ></sp-mat-select-search>
            </div>
            <div>
              <span class="w-2/5 field-label">Target group</span>
              <sp-mat-select-search
                class="w-3/5 inline-block"
                formControlName="targetGroup"
                [dataSource]="targetTypes"
                [placeholder]="'Select target group'"
                [config]="{ search: true, required: true, requiredText: 'Target group is required' }"
                [attrDataTestId]="'custom-client-metadata_target_group'"
              ></sp-mat-select-search>
            </div>
            <div>
              <span class="w-2/5 field-label">Agency</span>
              <mat-form-field appearance="outline" color="primary" class="w-3/5">
                <input type="text" placeholder="Agency" matInput formControlName="agency" />
              </mat-form-field>
            </div>
            <div>
              <span class="w-2/5 field-label">Campaign year</span>
              <sp-mat-select-search
                class="w-3/5 inline-block"
                formControlName="campaignYear"
                [dataSource]="campaignYear"
                [placeholder]="'Select campaign year'"
                [config]="{ search: true }"
                [attrDataTestId]="'custom-client-metadata_campaign_year'"
              ></sp-mat-select-search>
            </div>
            <div>
              <span class="w-2/5 field-label">Contact person</span>
              <mat-form-field appearance="outline" color="primary" class="w-3/5">
                <input type="text" placeholder="Contact person" matInput formControlName="contactPerson" />
              </mat-form-field>
            </div>
            <div class="my-2">
              <span>Internal comments</span>
              <sp-editor
                formControlName="internalComments"
                placeholder="Collection Description"
                [maxLength]="5000"
                (usersList)="taggedUserList($event)"
                (descriptionText)="editorDescriptionText($event)"
              ></sp-editor>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
